"use strict";

var _slicedToArray = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");

var TX_DEFAULTS = {
  MAX_ATTACHMENT: 140,
  ALIAS: {
    AVAILABLE_CHARS: '-.0123456789@_abcdefghijklmnopqrstuvwxyz',
    MAX_ALIAS_LENGTH: 30,
    MIN_ALIAS_LENGTH: 4
  }
};
var ASSETS = {
  NAME_MIN_BYTES: 4,
  NAME_MAX_BYTES: 16,
  DESCRIPTION_MAX_BYTES: 1000
};

exports.defaultValue = function (value) {
  return function () {
    return value;
  };
};

exports.nope = function (value) {
  return value;
};

exports.pipe = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (value) {
    return args.reduce(function (acc, cb) {
      return cb(acc);
    }, value);
  };
};

exports.validatePipe = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return function (value) {
    var isValid = true;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cb = _step.value;
        isValid = !!cb(value);

        if (!isValid) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return isValid;
  };
};

exports.prop = function (key) {
  return function (value) {
    return value ? value[key] : undefined;
  };
};

exports.lte = function (ref) {
  return function (value) {
    return ref >= value;
  };
};

exports.gte = function (ref) {
  return function (value) {
    return ref <= value;
  };
};

exports.ifElse = function (condition, a, b) {
  return function (value) {
    return condition(value) ? a(value) : b(value);
  };
};

exports.isEq = function (reference) {
  return function (value) {
    switch (true) {
      case exports.isNumber(value) && exports.isNumber(reference):
        return Number(value) === Number(reference);

      case exports.isString(value) && exports.isString(reference):
        return String(reference) === String(value);

      case exports.isBoolean(value) && exports.isBoolean(reference):
        return Boolean(value) === Boolean(reference);

      default:
        return reference === value;
    }
  };
};

exports.orEq = function (referencesList) {
  return function (value) {
    return referencesList.some(exports.isEq(value));
  };
};

exports.isRequired = function (required) {
  return function (value) {
    return !required || value != null;
  };
};

exports.isString = function (value) {
  return typeof value === 'string' || value instanceof String;
};

exports.isNumber = function (value) {
  return (typeof value === 'number' || value instanceof Number) && !isNaN(Number(value));
};

exports.isNumberLike = function (value) {
  return value != null && !isNaN(Number(value)) && !!(value || value === 0);
};

exports.isBoolean = function (value) {
  return value != null && (typeof value === 'boolean' || value instanceof Boolean);
};

exports.isByteArray = function (value) {
  if (!value) {
    return false;
  }

  var bytes = new Uint8Array(value);
  return bytes.length === value.length && bytes.every(function (val, index) {
    return exports.isEq(val)(value[index]);
  });
};

exports.isArray = function (value) {
  return Array.isArray(value);
};

exports.bytesLength = function (length) {
  return function (value) {
    try {
      return Uint8Array.from(value).length === length;
    } catch (e) {
      return false;
    }
  };
};

exports.isBase58 = function (value) {
  try {
    ts_lib_crypto_1.base58Decode(value);
  } catch (e) {
    return false;
  }

  return true;
};

exports.isBase64 = function (value) {
  try {
    value = value.replace(/^base64:/, '');
    ts_lib_crypto_1.base64Decode(value);
  } catch (e) {
    return false;
  }

  return true;
};

exports.isValidAddress = function (address, network) {
  if (typeof address !== 'string' || !exports.isBase58(address)) {
    return false;
  }

  var addressBytes = ts_lib_crypto_1.base58Decode(address);

  if (addressBytes[0] !== 1) {
    return false;
  }

  if (network != null && addressBytes[1] != network) {
    return false;
  }

  var key = addressBytes.slice(0, 22);
  var check = addressBytes.slice(22, 26);
  var keyHash = ts_lib_crypto_1.keccak(ts_lib_crypto_1.blake2b(key)).slice(0, 4);

  for (var i = 0; i < 4; i++) {
    if (check[i] !== keyHash[i]) {
      return false;
    }
  }

  return true;
};

var validateChars = function validateChars(chars) {
  return function (value) {
    return value.split('').every(function (char) {
      return chars.includes(char);
    });
  };
};

exports.isValidAliasName = exports.ifElse(validateChars(TX_DEFAULTS.ALIAS.AVAILABLE_CHARS), exports.pipe(exports.prop('length'), exports.validatePipe(exports.lte(TX_DEFAULTS.ALIAS.MAX_ALIAS_LENGTH), exports.gte(TX_DEFAULTS.ALIAS.MIN_ALIAS_LENGTH))), exports.defaultValue(false));
exports.isValidAlias = exports.validatePipe(exports.isString, exports.pipe(function (value) {
  return value.split(':');
}, exports.ifElse(function (value) {
  return value[0] !== 'alias' || value.length !== 3;
}, exports.defaultValue(false), exports.pipe(exports.prop(2), exports.isValidAliasName))));
exports.isHash = exports.validatePipe(exports.isRequired(true), exports.isBase58, exports.pipe(function (value) {
  return ts_lib_crypto_1.base58Decode(value);
}, exports.bytesLength(32)));
exports.isPublicKey = exports.isHash;
exports.isAssetId = exports.ifElse(exports.orEq(['', null, undefined, 'WAVES']), exports.defaultValue(true), exports.isHash);
exports.isAttachment = exports.ifElse(exports.orEq([null, undefined]), exports.defaultValue(true), exports.pipe(exports.ifElse(exports.isBase58, ts_lib_crypto_1.base58Decode, exports.nope), exports.ifElse(exports.isByteArray, exports.pipe(exports.prop('length'), exports.lte(TX_DEFAULTS.MAX_ATTACHMENT)), exports.defaultValue(false))));
var validateType = {
  integer: exports.isNumberLike,
  boolean: exports.isBoolean,
  string: exports.isString,
  binary: exports.isBase64
};

exports.isValidDataPair = function (data) {
  return !!(validateType[data.type] && validateType[data.type](data.value));
};

exports.isValidData = exports.validatePipe(exports.isRequired(true), exports.pipe(exports.prop('key'), exports.validatePipe(exports.isString, function (key) {
  return !!key;
})), exports.isValidDataPair);
exports.isValidAssetName = exports.validatePipe(exports.isRequired(true), exports.isString, exports.pipe(ts_lib_crypto_1.stringToBytes, exports.prop('length'), exports.ifElse(exports.gte(ASSETS.NAME_MIN_BYTES), exports.lte(ASSETS.NAME_MAX_BYTES), exports.defaultValue(false))));
exports.isValidAssetDescription = exports.ifElse(exports.isRequired(false), exports.defaultValue(true), exports.pipe(ts_lib_crypto_1.stringToBytes, exports.prop('length'), exports.lte(ASSETS.DESCRIPTION_MAX_BYTES)));

exports.exception = function (msg) {
  throw new Error(msg);
};

exports.isRecipient = exports.ifElse(exports.isValidAddress, exports.defaultValue(true), exports.isValidAlias);

exports.validateByShema = function (shema, errorTpl) {
  return function (tx) {
    Object.entries(shema).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          cb = _ref2[1];

      var value = exports.prop(key)(tx || {});

      if (!cb(value)) {
        exports.exception(errorTpl(key, value));
      }
    });
    return true;
  };
};

exports.getError = function (key, value) {
  return "tx \"".concat(key, "\", has wrong data: ").concat(JSON.stringify(value), ". Check tx data.");
};